var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.426,
    height: 79.426,
    viewBox: "0 0 79.426 79.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chart-line",
    "data-name": "Icon metro-chart-line",
    d: "M78.609,75.313H72V72H68.681v3.316h-6.6V72H58.763v3.316H52.151V72H48.835v3.316H42.222V72H38.906v3.316H32.294V72H28.978v3.316H14.413L31.854,64.832l8.631-25.224L53.306,62.142,78.15,20.747l-5.672-3.409L53.458,49.03,38.976,23.577,26.37,60.4,9.112,70.776V2.5H2.5V81.926H81.926V72H78.61Zm0-72.814h3.316V5.815H78.609Zm-9.928,0H72V5.815H68.681Zm-9.918,0h3.316V5.815H58.763Zm-9.928,0h3.316V5.815H48.835Zm-9.928,0h3.316V5.815H38.906Zm-9.928,0h3.316V5.815H28.978Zm-9.928,0h3.316V5.815H19.05Zm-9.928,0h3.316V5.815H9.121Zm69.488,9.928h3.316v3.316H78.609Zm-9.928,0H72v3.316H68.681Zm-9.918,0h3.316v3.316H58.763Zm-9.928,0h3.316v3.316H48.835Zm-9.928,0h3.316v3.316H38.906Zm-9.928,0h3.316v3.316H28.978Zm-9.928,0h3.316v3.316H19.05Zm-9.928,0h3.316v3.316H9.121Zm69.488,9.918h3.316v3.316H78.609Zm-19.847,0h3.316v3.316H58.763Zm-9.928,0h3.316v3.316H48.835Zm-19.857,0h3.316v3.316H28.978Zm-9.928,0h3.316v3.316H19.05Zm-9.928,0h3.316v3.316H9.121Zm69.488,9.928h3.316V35.59H78.609Zm-29.775,0h3.316V35.59H48.835Zm-19.857,0h3.316V35.59H28.978Zm-9.928,0h3.316V35.59H19.05Zm-9.928,0h3.316V35.59H9.121Zm69.488,9.935h3.316v3.316H78.609Zm-9.928,0H72v3.316H68.681Zm-49.631,0h3.316v3.316H19.05Zm-9.928,0h3.316v3.316H9.121Zm69.488,9.928h3.316v3.316H78.609Zm-9.928,0H72v3.316H68.681Zm-29.775,0h3.316v3.316H38.906Zm-19.857,0h3.316v3.316H19.05Zm-9.928,0h3.316v3.316H9.121Zm69.488,9.918h3.316v3.316H78.609Zm-9.928,0H72v3.316H68.681Zm-9.918,0h3.316v3.316H58.763Zm-19.857,0h3.316v3.316H38.906Zm-29.785,0h3.316v3.316H9.121Z",
    transform: "translate(-2.499 -2.499)",
    fill: "aqua"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.004748cf172c52c5eff270a6690321d8.svg";
export { ForwardRef as ReactComponent };